import getCookie from '../../../partials/cookie';
import AcceptRegulations from './AcceptRegulations';

function AskQuestion(props) {
    let csrftoken = getCookie('csrftoken')
    const {default_category, if_WK, uuid} = props
    let send_url = ''

    if (if_WK) {
        send_url = `/zapytaj-prawnika/kategoria/${default_category}/`
    } else {
        send_url = '/zapytaj-prawnika/'
    }

  return (
    <div className="homepage-form problem" >
        <div className="title">
            <a href="/zapytaj-prawnika/">
                <img src="/media/img/home/pytanie_ikona.png" alt="ikona-zadaj-pytanie"/>
            </a>
            <h1>Zadaj bezpłatne pytanie lub poproś o&nbsp;wycenę</h1>
        </div>
        <form action={send_url} method="POST" className={`form-horizontal ${if_WK ? 'WK-form' : ''}`} preventdefault='true'>
            <input type="hidden" name="csrfmiddlewaretoken" value={csrftoken} autoComplete="off"></input>
            {if_WK? <input type="hidden" name="aid" value={uuid} /> : null}
            <div>
                <label htmlFor="id_city">Miejscowość:</label>
                <input type="text" name="city" placeholder="np. Poznań" required id="id_city"/>
                <div className="form-group margin-buffer">
                    <label htmlFor="id_problem">Opis szczegółowy (do 600 znaków):</label>
                    <textarea name="problem" cols="40" rows="10" placeholder="Wpisz np. Czy mogę starać się o alimenty na dziecko, jeśli nie wiem gdzie przebywa ojciec" required id="id_problem"></textarea>
                </div>
                <div className="form-group margin-buffer">
                    <label htmlFor="qemail">E-mail</label>
                    <input id="qemail" type="email" name="email" placeholder="np. klient@example.com" required/>
                    <div className="help-block">Otrzymasz odpowiedzi na podany adres oraz informację o prawniku i możliwości dalszego kontaktu z nim.
                    Prawnikom nie zostanie przekazana informacja o Twoim adresie e-mail.
                    </div>
                </div>
                <AcceptRegulations />
                <button type="submit" className="btn btn-primary center-block consultation-button">Wyślij pytanie
                </button>
            </div>
        </form>
    </div>
  )
}

export default AskQuestion